// eslint-disable-next-line no-undef
if (process.env.NODE_ENV === 'production') {
    // eslint-disable-next-line no-undef
    __webpack_public_path__ = '/wp-content/plugins/gif-register-by-owl360/dist/';
}

import { createApp } from 'vue'
import eventBus from '@/js/eventBus';
import { Genv } from '@/js/global';
import App from '@/registerPage.vue'
import App2 from '@/widgetLoad.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons' // Importa los íconos que necesitas, en este caso, todos los íconos sólidos
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'tabulator-tables/dist/css/tabulator.min.css';
import isMobileLoad from '@/plugins/isMobile.js';
import { getMixin } from "@/js/mixin.js"
Genv.title = ""


library.add(fas) // Añade los íconos al library

let app = "";
if (window.widget === true) app = createApp(App2);
else app = createApp(App);

// Registra el componente FontAwesomeIcon globalmente
app.component('font-awesome-icon', FontAwesomeIcon)

app.use(isMobileLoad).mixin(getMixin())
app.config.globalProperties.$eventBus = eventBus;
app.config.globalProperties.$mouse = false;

Genv.eventBus = eventBus;
eventBus.on("mousePosition", (mouse) => {
    Genv.mouse = mouse
    app.config.globalProperties.$mouse = true;
})
app.mount('#app');
window.vueApp = app;
window.vueGenv = Genv;